<template>
  <Modal closable>
    <template v-slot:header>
      <h2>{{ $t('confirm.title') }}</h2>
    </template>
    
      <p v-if="desc" v-html="desc"></p>

    <template v-slot:footer>
        <AppButton @click="cancel()">{{ $t('confirm.no') }}</AppButton>
        <AppButton @click="confirm()" color="error">{{ $t('confirm.yes') }}</AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Confirm',
  props: {
    title: String,
    desc: String
  },
  setup(props, { emit }) {
    function cancel() {
      emit('cancel', true)
    }
    function confirm() {
      emit('confirm', true)
    }
    return { cancel, confirm }
  }
})
</script>

<style>

</style>